// src/components/ZoomImage.jsx
import React, { useState, useRef, useEffect } from 'react';

const ZoomImage = ({ src, alt, className = '' }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);
  const zoomRef = useRef(null);
  const imgRef = useRef(null);

  // Проверка на десктоп
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    const checkDevice = () => {
      setIsDesktop(window.matchMedia('(min-width: 768px)').matches);
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!isDesktop) {
    return (
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={className}
        onError={(e) => (e.target.src = '/placeholder.jpg')}
      />
    );
  }

  const handleMouseMove = (e) => {
    if (!containerRef.current || !imgRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    const imgRect = imgRef.current.getBoundingClientRect();

    // Позиция курсора относительно контейнера изображения
    const x = e.clientX - imgRect.left;
    const y = e.clientY - imgRect.top;

    // Нормализуем координаты (0–1)
    const xPercent = x / imgRect.width;
    const yPercent = y / imgRect.height;

    // Ограничиваем, чтобы курсор не выходил за границы
    const boundedX = Math.max(0, Math.min(1, xPercent));
    const boundedY = Math.max(0, Math.min(1, yPercent));

    setOffset({ x: boundedX, y: boundedY });

    // Позиционируем лупу рядом с курсором
    const zoomWidth = 320;
    const zoomHeight = 320;
    let zoomX = e.clientX + 20;
    let zoomY = e.clientY + 20;

    if (zoomX + zoomWidth > window.innerWidth) zoomX = e.clientX - zoomWidth - 20;
    if (zoomY + zoomHeight > window.innerHeight) zoomY = e.clientY - zoomHeight - 20;

    if (zoomRef.current) {
      zoomRef.current.style.left = `${zoomX}px`;
      zoomRef.current.style.top = `${zoomY}px`;
    }
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full h-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onMouseMove={handleMouseMove}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={className}
        onError={(e) => (e.target.src = '/placeholder.jpg')}
      />

      {/* Лупа с увеличением */}
      {isHovered && (
        <div
          ref={zoomRef}
          className="fixed w-80 h-80 border border-brand-border dark:border-brand-border rounded-lg overflow-hidden shadow-xl z-50 pointer-events-none"
          style={{
            background: `url(${src}) no-repeat`,
            backgroundSize: `${imgRef.current?.naturalWidth * 2}px ${imgRef.current?.naturalHeight * 2}px`, // Увеличение в 2x
            backgroundPosition: `-${offset.x * (imgRef.current?.naturalWidth * 2 - 320)}px -${offset.y * (imgRef.current?.naturalHeight * 2 - 320)}px`,
          }}
        />
      )}
    </div>
  );
};

export default ZoomImage;